export const LEGAL_LINKS = Object.freeze({
  privacyPolicy: "https://nexorasystems.ca/privacy",
  termsOfService: "https://nexorasystems.ca/terms",
  accountDeletion: "https://nexorasystems.ca/account-deletion",
});
